import { createFormAction } from 'redux-form-saga'
export const LOGIN_FORM_KEY = 'LOGIN_FORM_KEY'
export const LoginFormAction = createFormAction(LOGIN_FORM_KEY)

export const REGISTER_FORM_KEY = 'REGISTER_FORM_KEY'
export const RegisterFormAction = createFormAction(REGISTER_FORM_KEY)

export const FORGET_FORM_KEY = 'FORGET_FORM_KEY'
export const ForgetFormAction = createFormAction(FORGET_FORM_KEY)
